export const PluginConnectSlim = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6663 8.33341H8.99967C7.52692 8.33341 6.33301 9.52732 6.33301 11.0001V19.0001C6.33301 21.9456 8.72082 24.3334 11.6663 24.3334H15.9997M11.6663 8.33341V3.66675M11.6663 8.33341H20.333M20.333 8.33341H22.9997C24.4724 8.33341 25.6663 9.52732 25.6663 11.0001V19.0001C25.6663 21.9456 23.2785 24.3334 20.333 24.3334H15.9997M20.333 8.33341V3.66675M15.9997 24.3334V28.3334"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PluginConnectSlim
